var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-row',{staticClass:"page-wrapper have-bottom-menu",attrs:{"justify":"center"}},[_c('van-col',{staticClass:"itserve-center",attrs:{"span":"24"}},[_c('info-message',[_vm._v(" "+_vm._s(_vm.$t("regionalEnergy.enterpriseServices.comingSoon")))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }